import { FC } from 'react';
import cn from 'classnames';
import { Loading } from '@geist-ui/core';

const LoadingData: FC<{ alternative?: boolean }> = ({
  alternative = false,
}) => (
  <div
    className={cn('loading-data', {
      'loading-data--main': !alternative,
      'loading-data--alternative': alternative,
    })}
  >
    <Loading>Loading</Loading>
  </div>
);

export default LoadingData;
